// extracted by mini-css-extract-plugin
export default {"colorsPicker":"ColorsPicker_colorsPicker__U2jbG","deleteIcon":"ColorsPicker_deleteIcon__7PBBj","colorBars":"ColorsPicker_colorBars__MpCV5"};